import MatomoTracker from '@jonkoops/matomo-tracker'
const ls = require('localstorage-slim');
import md5 from '../helper/md5';

const tracking = () => {

  // Initialize with your site ID and Matomo URL
  const matomo = new MatomoTracker({
    urlBase: 'https://matomo.glamydays.de',
    siteId: 1,
    linkTracking: false, // optional, default value: true
  })

  const likeBtns = document.querySelectorAll('a[data-action="like"]');
  if(likeBtns) {
    likeBtns.forEach(likeBtn => {

      const likeRef = likeBtn.dataset.id;
      if(!ls.get(likeRef)) {

        likeBtn.addEventListener('click',() => {
          matomo.trackEvent({
            category: 'user-actions',
            action: 'user-like',
            value: likeRef
          });

          ls.set(likeRef,Date.now())
          likeBtn.classList.add('--filled');
        });
      } else {
        likeBtn.classList.add('--filled');
        likeBtn.addEventListener('click',() => {
          matomo.trackEvent({
            category: 'user-actions',
            action: 'user-dislike',
            value: likeRef
          });

          ls.remove(likeRef)
          likeBtn.classList.remove('--filled');
        })
      }


    })
  }


}

tracking();
